import React from 'react';
import { ToggleOn } from '@wix/wix-ui-icons-common/system';
import { LinearProgressBarCore } from './LinearProgressBarCore';
import { StatusIndicator } from '../StatusIndicator';
import { dataHooks } from './LinearProgressBar.constants';
import { useIcons } from '../WixDesignSystemIconThemeProvider';
import {
  LinearProgressBarProps,
  LinearProgressBarSkin,
} from './LinearProgressBar.types';
import type { LinearProgressBarPropsWithAria } from './LinearProgressBarCore/LinearProgressBarCore';

type ControlledCoreProps =
  | 'className'
  | 'data-hook'
  | 'error'
  | 'errorIcon'
  | 'successIcon'
  | 'rootModifiers';

type LinearProgressBarInternalProps = LinearProgressBarProps &
  Partial<Omit<LinearProgressBarPropsWithAria, ControlledCoreProps>>;

const defaultSkin: LinearProgressBarSkin = 'standard';

function LinearProgressBar({
  errorMessage,
  skin = defaultSkin,
  light,
  dataHook,
  error,
  padding,
  height,
  ...otherProps
}: LinearProgressBarInternalProps) {
  const icons = useIcons('LinearProgressBar', {
    ToggleOn,
  });

  return (
    <LinearProgressBarCore
      data-hook={dataHook}
      rootModifiers={{ light, skin, padding, height }}
      data-skin={skin}
      data-padding={padding}
      {...otherProps}
      error={error}
      successIcon={<icons.ToggleOn />}
      errorIcon={
        <StatusIndicator
          dataHook={dataHooks.errorIcon}
          status="error"
          message={errorMessage}
        />
      }
    />
  );
}

LinearProgressBar.displayName = 'LinearProgressBar';

export { LinearProgressBar };
